import type { ServicePageData } from './types';

const magneticPanels: ServicePageData = {
  slug: 'magnetic-panels',
  eyebrow: 'Vehicle graphics',
  eyebrowTo: '/services/vehicle-signwriting',
  title: 'Promote your business…',
  titleAccent: 'sometimes',
  intro:
    'Magnetic signs are the perfect solution when you need your branding to be removable or interchangeable. You can quickly remove the panels when subcontracting or swap out panels if you have multiple businesses.',
  heroPrimaryButtonText: 'Explore Options',
  heroSecondaryButtonText: 'Get in Touch',
  hidePerfectFor: true,
  heroImages: [
    '/home/vehicles/magnetic-hero.jpg',
    '/home/vehicles/magnetic-large-panel.jpg',
    '/home/vehicles/magnetic-small-panel.jpg',
    '/home/vehicles/magnetic-custom-panel.jpg',
    '/home/vehicles/magnetic-bewdley-candle.jpg',
    '/home/vehicles/magnetic-bridgwaters.jpg',
    '/home/vehicles/magnetic-paisley.jpg',
  ],

  useCases: [
    { title: 'Business and personal use', text: 'Advertise on the way to a job, then take the panels off for the weekend.' },
    { title: 'Multiple companies, one vehicle', text: 'Swap between panel sets if you consult or trade under more than one name.' },
    { title: 'Pool and lease vehicles', text: 'Brand a vehicle without affecting its condition or resale value.' },
    { title: 'Short-term promotions', text: 'A campaign, event or seasonal offer without paying for permanent vinyl.' },
    { title: 'Contractors and trades', text: 'Doors, van sides and the bonnet, sized to your panel and colour-matched to the paint.' },
  ],

  optionsHeading: 'What do we offer',
  // HD is supplying the paragraphs and replacement photos for these three finishes.
  options: [
    {
      id: 'white-panels-with-decals',
      title: 'White panels with decals',
      lead: '',
      body: '',
      image: '/home/vehicles/magnetic-large-panel.jpg',
    },
    {
      id: 'colour-matched-backgrounds',
      title: 'Colour matched backgrounds',
      lead: '',
      body: '',
      image: '/home/vehicles/magnetic-small-panel.jpg',
    },
    {
      id: 'full-colour-printed-graphics',
      title: 'Full colour printed graphics',
      lead: '',
      body: '',
      image: '/home/vehicles/magnetic-custom-panel.jpg',
    },
  ],

  hideCustomisation: true,

  gallery: [],

  info: [
    {
      title: 'Supply only',
      text: 'Panels arrive ready to apply straight to clean, dry bodywork. No tools needed.',
      bullets: ['Collect from Kidderminster', 'Delivery from £10'],
    },
    {
      title: 'Care',
      text: 'Remove the panels at least once a week and wash and dry the paint underneath, even if you plan to put them straight back on.',
      bullets: ['Do not apply to a new paint job, clear coat or wax until it has fully cured', 'Store flat, magnet-side together, out of direct sun'],
    },
    {
      title: 'Turnaround',
      text: 'Production is 5 to 10 working days from approval. Free design mockup and quote before you commit to anything.',
    },
  ],

  faqs: [
    {
      q: 'Will magnetic panels damage my paintwork?',
      a: 'Not if you look after them. Take them off regularly to clean underneath, and avoid leaving them in one place for long stretches, especially in direct sun.',
    },
    {
      q: 'How long do magnetic panels last?',
      a: 'About two years with proper care, then we would recommend replacing them before the magnet or the print starts to lose its grip or fade.',
    },
    {
      q: 'Will they stay on at motorway speed?',
      a: 'Panels are designed for road use on flat or gently curved panels. Check the edges are properly seated before setting off, and avoid dipped or ribbed panels where they cannot sit flush.',
    },
    {
      q: 'Can I put a panel on a curved bonnet?',
      a: 'A gentle curve is fine. Sharp curves, ribs or dips stop the panel sitting flat, which weakens the hold, so send us a photo if you are unsure.',
    },
  ],

  howItWorksTone: 'dark',
  darkFaq: true,
  greenCta: true,

  cta: {
    title: 'Get your free magnetic panel quote and mockup.',
    text: 'Tell us the vehicle and where the panels are going, and we will recommend the size and shape.',
    image: '/home/vehicles/magnetic-bridgwaters.jpg',
  },
};

export default magneticPanels;
